export default __webpack_public_path__ + "static/media/poland.b0e11737.svg";